import React, { useContext, useState } from 'react'
import { MdOutlineArrowBack } from 'react-icons/md'
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/auth_context';
import { RecoverPass, Service } from '../../services/api';
import pdf from '../../docs/politicas.pdf'
import { AlertContext } from '../../context/alert_context';
import Renderif from '../../components/renderif';
import Loader from '../../components/loader';

export default function RecuperarPassView() {
  const { setUser } = useContext(AuthContext)
  const { notify } = useContext(AlertContext)
  const [state, setState] = useState({
    email: '',
    loading: false,
    error: '',
    tab:0
  })
  const navigate = useNavigate();

  const onRecoverPass = async () => {
    
    if (
      state.email === ''

    ) {
      notify({ title: 'Alerta', message: 'Es necesario ingresar tu correo electrónico', type: 'error' })
      return;
    }

    setState({ ...state, loading: true })

    let recoverPass = await RecoverPass({
      "email": state.email,
    })
    
    if (recoverPass?.status !== 200) {
      notify({ title: 'Alerta', message: 'Algo salio mal, intentalo de nuevo más tarde', type: 'error' })
      setState({ ...state, loading: false })
      return;
    }
    setState({ ...state, tab: 1 })

  }
  return (
    <>
      <Renderif isTrue={state.loading}>
        <Loader></Loader>
      </Renderif>
      <div className='continaer-fluid h-100'>
        <div className='row p-0 m-0 h-100'>

          <div className='col-12 col-md-6 d-flex flex-column justify-content-center align-items-center'>
            <div className='bv-login-form'>

              <div className='d-flex flex-column align-items-center pb-3'>
                <div className='my-4'>
                  <img width={180} src='assets/logo.png'></img>
                </div>
                <div className='bold f-22 text-gray'>Ingresa tu correo electrónico</div>
                <div className='f-12 text-gray text-center px-3'></div>
              </div>


              <div className='d-inline-flex align-items-center highlight-text-hover cursor-pointer' onClick={() => {
                navigate(-1)
              }}>
                <div className='bv-icon bv-icon--mid'><MdOutlineArrowBack size={20} color={'#777777'}></MdOutlineArrowBack></div>
                <div className='text-gray f-14 line-0'>Regresar</div>

              </div>
              <Renderif isTrue={state.tab===0}>
                <div className='pt-2'>
                  <div className='f-12 bold text-gray'>Email*</div>
                  <input value={state.email} onChange={(e) => {
                    setState({ ...state, email: e.currentTarget.value })
                  }} className='input--light'></input>
                </div>
                <div className='f-12 text-red'>{state.error}</div>
                <div className='py-3'>
                  <div className='bv-cta bv-cta--primary w-100' onClick={() => { onRecoverPass() }}>
                    <div className='text-center w-100'>Continuar</div>
                  </div>

                  {/* <a target='_blank'  href={'/politicas'}><div className='f-12 text-primary text-decoration-underline cursor-pointer text-center mt-3'>Aviso de privacidad</div></a> */}

                  <a target='_blank' href='https://bienvivir-static.s3.us-east-2.amazonaws.com/politicas.pdf'><div className='f-12 text-primary text-decoration-underline cursor-pointer text-center mt-3'>Aviso de privacidad</div></a>

                </div>
              </Renderif>
              <Renderif isTrue={state.tab===1}>
              <div className='text-gray f-14 line-0'>En breve recibirás un correo electrónico para recuperar tu contraseña.</div>
              </Renderif>
            </div>

          </div>

          <div className='col p-0 d-none d-md-block'>
            <div className='bv-login-bg'></div>
          </div>

        </div>
      </div>
    </>
  )
}
